export enum BreakpointsTypes {
    XXS = "xxs",
    XS = "xs",
    S = "s",
    M = "m",
    L = "l",
    XL = "xl",
    XXL = "xxl",
}

export interface IBreakpoints {
    [BreakpointsTypes.XXS]: boolean;
    [BreakpointsTypes.XS]: boolean;
    [BreakpointsTypes.S]: boolean;
    [BreakpointsTypes.M]: boolean;
    [BreakpointsTypes.L]: boolean;
    [BreakpointsTypes.XL]: boolean;
    [BreakpointsTypes.XXL]: boolean;
}

export enum DirectionType {
    HEIGHT = "height",
    WIDTH = "width"
}
